<template>
  <el-dialog
      class="dialog"
      width="90%"
      height="60vh"
      :destroy-on-close="true"
      title="编辑发型师服务"
      top="1vh"
      :visible.sync="visible">
    <div>
      <div>
        <div class="top-container container">
          <div class="item">
            <span class="label">显示描述</span>
            <span class="value">
              <el-input class="w300" v-model="form.serviceDescribe" size="small"
                        placeholder="请输入显示描述"></el-input>
            </span>
          </div>
          <div class="item">
            <span class="label">显示价格</span>
            <span class="value">
              <el-input v-model="form.maxPrice" :precision="2" :min="0" type="number" size="small"></el-input>
            </span>
          </div>
          <div>
            <span class="label">预约服务</span>
            <span class="value">
              <el-switch v-model="form.subscribe" :active-value="1" :inactive-value="0"/>
            </span>
            <span v-if="form.subscribe">
              <el-time-select placeholder="起始时间" v-model="form.subscribeTimes[0]" :picker-options="{
                start: '09:00',
                step: '00:30',
                end: '23:59',
              }" size="small" style="width:150px; margin-right: 5px" @blur="$forceUpdate()">
              </el-time-select>
              <el-time-select placeholder="结束时间" v-model="form.subscribeTimes[1]" :picker-options="{
                start: '09:30',
                step: '00:30',
                end: '23:59',
                minTime: startTime,
              }" size="small" style="width:150px" @blur="$forceUpdate()">
              </el-time-select>
            </span>
          </div>
        </div>
      </div>
      <div class="container" style="margin: 20px 0; justify-content: space-between">
        <div class="item">
          <span class="label">项目</span>
          <span class="value">
            <el-select size="small" placeholder="请选择项目" style="width: 100%" filterable
                       @change="handleSelectService">
              <el-option v-for="(item, index) in serviceList" :key="index" :label="item.title"
                         :value="item.id" :disabled="selectedService.includes(item.id)"></el-option>
            </el-select>
          </span>
        </div>
        <div class="item">
          <span class="label"></span>
          <span class="value">
            <el-button type="primary" @click="handleCopy" size="small">复制所有设置</el-button>
            <el-button type="primary" @click="handlePaste" size="small">粘贴所有设置</el-button>
          </span>
        </div>
      </div>
      <div class="">
        <!-- 表格 -->
        <el-table :data="workerServiceList" :header-cell-style="{background:'#F2F2F4'}" style="width: 100%">
          <!-- 姓名列 -->
          <el-table-column label="项目分类" fixed>
            <template #default="{ row }">
              <span>{{ getServiceName(row.type) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="项目" prop="serverName" fixed width="120"></el-table-column>
          <el-table-column label="排序" width="100">
            <template #default="{ row }">
              <el-input v-model="row.sort" type="number" :min="0" size="small"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="价格" width="120" class-name="price-column" >
            <template #default="{ row }">
              <el-input v-model="row.price" type="number" :min="0" size="small"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="闲时优惠">
            <template #default="{ row }">
              <el-switch v-model="row.isLeisure" :active-value="true" :inactive-value="false"/>
            </template>
          </el-table-column>
          <el-table-column label="闲时价格" width="120">
            <template #default="{ row }">
              <el-input v-model="row.leisurePrice" type="number" :min="0" size="small"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="闲时范围" width="150">
            <template #default="{ row }">
              <el-time-select placeholder="起始时间" v-model="row.leisureStartTime" :picker-options="{
                  start: '09:00',
                  step: '00:10',
                  end: '23:59',
                }" style="width:120px" @blur="$forceUpdate()" size="small">
              </el-time-select>
              <el-time-select placeholder="结束时间" v-model="row.leisureEndTime" :picker-options="{
                  start: '09:30',
                  step: '00:10',
                  end: '23:59',
                  minTime: startTime,
                }" style="width:120px" @blur="$forceUpdate()" size="small">
              </el-time-select>
            </template>
          </el-table-column>
          <el-table-column label="新人优惠" width="120">
            <template #default="{ row }">
              <el-input v-model="row.newUserPrice" type="number" :min="0" size="small"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="业绩" width="180">
            <template #default="{ row }">
              <el-select v-model="row.commissionType" size="small">
                <el-option :value="1" label="实收(支付价格)"></el-option>
                <el-option :value="2" label="虚业绩(服务价格)"></el-option>
                <el-option :value="3" label="设定值"></el-option>
              </el-select>
              <el-input v-if="row.commissionType === 3" v-model="row.commission" type="number" :min="0"
                        placeholder="请输入业绩" size="small"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="标签" min-width="120">
            <template #default="{ row }">
              <el-input v-model="row.tag" size="small"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="服务时长" width="100">
            <template #default="{ row }">
              <el-input v-model="row.serviceTime" type="number" size="small"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="项目描述" min-width="180">
            <template #default="{ row }">
              <el-input v-model="row.description" size="small"></el-input>
            </template>
          </el-table-column>
          <!-- 操作列 -->
          <el-table-column label="操作" fixed="right">
            <template #default="{ $index }">
              <el-button type="danger" size="small" @click="deleteRow($index)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="container" style="margin-top: 20px">
        <div class="item">
          <span class="label">新人优惠适用天数</span>
          <span class="value">
            <el-checkbox-group v-model="form.newUserPriceWorkdays">
              <el-checkbox label="1">星期一</el-checkbox>
              <el-checkbox label="2">星期二</el-checkbox>
              <el-checkbox label="3">星期三</el-checkbox>
              <el-checkbox label="4">星期四</el-checkbox>
              <el-checkbox label="5">星期五</el-checkbox>
              <el-checkbox label="6">星期六</el-checkbox>
              <el-checkbox label="7">星期日</el-checkbox>
            </el-checkbox-group>
          </span>
        </div>
      </div>
      <div class="" style="line-height: 35px; margin-top: 30px">
        <h3>业绩计算</h3>
        <div class="item">
          <span class="label">抖音券订单业绩</span>
          <span class="value">
            <el-input v-model="form.douyinCommission" type="number" size="small"></el-input>
          </span>
        </div>
        <div class="item">
          <span class="label">卡金业绩</span>
          <span class="value">
            <el-radio-group v-model="form.kajinPerformance">
              <el-radio :label="0">不统计</el-radio>
              <el-radio :label="1">统计</el-radio>
            </el-radio-group>
          </span>
        </div>
        <div class="item">
          <span class="label">卡金/套餐提成</span>
          <span class="value">
            <el-radio-group v-model="form.kajinCommission">
              <el-radio :label="0">不统计</el-radio>
              <el-radio :label="1">统计</el-radio>
            </el-radio-group>
          </span>
        </div>
        <div class="item">
          <span class="label">会员提成</span>
          <span class="value">
            <el-input v-model="form.uvipCommission" type="number" size="small"></el-input>
          </span>
        </div>
      </div>

      <div style="text-align: center; margin-top: 30px">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="saveAll">保存</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      visible: false,
      serviceTypes: [
        { type: -1, name: '团购优惠' },
        { type: 0, name: '剪发' },
        { type: 1, name: '烫染' },
        { type: 2, name: '洗吹' },
        { type: 3, name: '护理' },
        { type: 4, name: '造型' },
        { type: 5, name: '迷你烫' },
        { type: 6, name: '健康染发' },
        { type: 7, name: '健康烫发' },
        { type: 8, name: '洗吹护理' },
        { type: 9, name: '美甲' },
        { type: 10, name: '接发' },
        { type: 11, name: '特惠项目' }
      ],
      serviceList: [],
      workerServiceList: [],
      selectedService: [],
      startTime: '',
      id: '',
      form: {
        serviceDescribe: '',
        maxPrice: null,
        subscribe: 0,
        subscribeTimes: [],
        newUserPriceWorkdays: [],
        douyinCommission: 0,
        kajinPerformance: 0,
        kajinCommission: 0,
        uvipCommission: 0
      }
    }
  },
  methods: {
    show(id) {
      this.id = id
      this.visible = true
      this.handleFetchService()
      this.handleGetService(this.id)
    },
    handleFetchService() {
      this.$http.get("dhaircut/option").then(({data}) => {
        this.serviceList = data.data
      })
    },
    handleGetService(id) {
      this.loading = true;
      this.serviceList = []
      this.$http.get("dWorker/service/" + id).then((res) => {
        const data = res.body.data
        this.form = data.form
        this.workerServiceList = data.workerServers
        let selectedService = []
        data.workerServers.forEach(ele => {
          selectedService.push(ele.serviceId)
        })
        this.selectedService = selectedService
        this.loading = false;
      });
    },
     getServiceName(type) {
      const serviceTypes = this.serviceTypes

      // 查找匹配的 serviceType 对象
      const service = serviceTypes.find(item => item.type === type);

      // 如果找到，返回其 name；否则返回 '未知服务'
      return service ? service.name : '未知服务';
    },
    handleSelectService(id) {
      const item = this.serviceList.find(service => service.id === id);
      const workerServiceItem = {
        type: item.type,
        serviceId: item.id,
        serverName: item.title,
        price: item.price,
        description: item.msg,
        serviceTime: 10,
        isLeisure: false,
        leisurePrice: 0,
        leisureStartTime: null,
        leisureEndTime: null,
        tag: '',
        newUserPrice: 0,
        sort: 0,
        commissionType: 3,
        commission: null,
      }
      this.selectedService.push(item.id)
      this.workerServiceList.push(workerServiceItem)
    },
    // 复制发型师id
    async handleCopy() {
      try {
        const content = this.id
        if (navigator.clipboard) {
          await navigator.clipboard.writeText(content);
        } else {
          // 兼容旧版浏览器的降级方案
          const textarea = document.createElement('textarea')
          textarea.value = content
          document.body.appendChild(textarea)
          textarea.select()
          document.execCommand('copy')
          document.body.removeChild(textarea)
        }
        this.$message.success("已复制到剪贴板！");
      } catch (err) {
        this.$message.error("复制失败");
        console.error("复制失败：", err);
      }
    },
    async handlePaste() {
      let text = '';
      try {
        if (!navigator.clipboard) {
          console.error('浏览器不支持 Clipboard API 或运行在http中');
          this.$message.error("浏览器不支持黏贴或运行在http中，请重试！");
          return;
        }
        text = await navigator.clipboard.readText();
        console.log("通过 navigator.clipboard 获取的内容：", text);
      } catch (error) {
        console.error("navigator.clipboard 读取失败：", error);
        this.$message.error("粘贴失败，" + error);
        return
      }
      console.log("text 读取结果：", text);
      // 校验剪贴板内容
      if (text == null || !text.trim()) {
        this.$message.error("未检测到剪贴板内容，请重试！");
        return;
      }
      if (!/^\d+$/.test(text)) {
        this.$message.error("当前剪切板内容错误！");
        return;
      }
      this.$message.success("已粘贴剪切板设置！");
      this.handleGetService(text)
    },
    // 回退方法：使用 document.execCommand
    fallbackPaste() {
      return new Promise((resolve) => {
        const input = document.createElement('input');
        document.body.appendChild(input);
        input.focus();
        // 需要用户主动触发（如点击）
        input.addEventListener('paste', (e) => {
          const pastedText = e.clipboardData.getData('text');
          document.body.removeChild(input);
          resolve(pastedText);
        });
        // 模拟用户粘贴（需用户手势）
        setTimeout(() => {
          document.execCommand('paste');
        }, 0);
      });
    },
    // 删除某一行
    deleteRow(index) {
      const item = this.workerServiceList[index];
      this.$confirm("确定要删除该行吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // 删除指定索引的行
        this.workerServiceList.splice(index, 1);
        this.selectedService = this.selectedService.filter(id => id !== item.serviceId)
        this.$message.success("删除成功！");
      }).catch(() => {
        this.$message.info("已取消删除");
      });
    },
    // 保存所有修改
    saveAll() {
      // 遍历数组并处理 leisureStartTime 字段
      this.workerServiceList.forEach(item => {
        if (item.leisureStartTime && item.leisureStartTime.length === 5) {
          // 如果时间格式为 "HH:mm"，则补充 ":00"
          item.leisureStartTime += ":00";
        }
        if (item.leisureEndTime && item.leisureEndTime.length === 5) {
          // 如果时间格式为 "HH:mm"，则补充 ":00"
          item.leisureEndTime += ":00";
        }
      });
      this.$http.post("dWorker/service/" + this.id, JSON.stringify({
        workerServers: this.workerServiceList,
        form: this.form
      })).then(({data}) => {
        if (data.code === 200) {
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.visible = false
            }
          })
        } else {
          this.$message.error(data.msg)
        }
      });
    }
  }
}
</script>
<style scoped lang="less">
.w300 {
  width: 300px;
}

.label {
  font-weight: bold;
  margin-right: 15px;
}

.value {

}

.container {
  display: flex;
  align-items: center;
}

.item {
  display: flex;
  align-items: center;
}

.top-container {
  div {
    margin-right: 20px;
  }
}

.flex-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

header {
  height: 60px;
}

footer {
  height: 80px;
}

.content {
  flex: 1;
  display: flex;
}

aside {
  width: 200px;
  background: #e8e8e8;
}

main {
  flex: 1;
  background: #fff;
}

/* 关键点2: 用深度选择器穿透样式 */
::v-deep .price-column .el-input__inner {
  border-color: red;
  color: red;
}
</style>